import { Box, Divider, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PatientSideListSkeleton } from 'src/components/PatientSideListSkeleton';
import { dataTestIds } from 'src/constants/data-test-ids';
import AiSuggestion from 'src/features/visits/in-person/components/AiSuggestion';
import { AiObservationField, getQuestionnaireResponseByLinkId, ObservationTextFieldDTO } from 'utils';
import { useAppointmentData, useChartData } from '../../../stores/appointment/appointment.store';

export const MedicalConditionsPatientColumn: FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { questionnaireResponse, isAppointmentLoading } = useAppointmentData();
  const { chartData } = useChartData();

  const medicalConditions = getQuestionnaireResponseByLinkId('medical-history', questionnaireResponse)?.answer?.[0]
    ?.valueArray;

  const legacyMedicalConditions = getQuestionnaireResponseByLinkId('medical-conditions-list', questionnaireResponse)
    ?.answer;

  const activeConditions =
    legacyMedicalConditions && legacyMedicalConditions.length > 0
      ? legacyMedicalConditions.map((a) => ({ 'medical-history-form-medical-condition': a.valueString }))
      : medicalConditions;

  const aiPastMedicalHistory = chartData?.observations?.filter(
    (observation) => observation.field === AiObservationField.PastMedicalHistory
  ) as ObservationTextFieldDTO[];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
      data-testid={dataTestIds.medicalConditions.medicalConditionPatientProvidedList}
    >
      {isAppointmentLoading ? (
        <PatientSideListSkeleton />
      ) : activeConditions ? (
        activeConditions.map((answer, index, arr) => (
          <Box key={index}>
            <Typography>{answer['medical-history-form-medical-condition']}</Typography>
            {index + 1 !== arr.length && <Divider sx={{ pt: 1 }} />}
          </Box>
        ))
      ) : (
        <Typography color={theme.palette.text.secondary}>{t('telemed.chart.noMedicalConditions')}</Typography>
      )}
      {aiPastMedicalHistory?.length > 0 && (
        <>
          <hr style={{ border: '0.5px solid #DFE5E9', margin: '0 -16px 0 -16px' }} />
          <AiSuggestion title={t('telemed.chart.pmhTitle')} chartData={chartData} content={aiPastMedicalHistory} />
        </>
      )}
    </Box>
  );
};
